import React from 'react';
import { OptionRoot } from '../OptionRoot';
import { Text, TEXT_VIEW } from "../../Text";
import { INDENT } from "../../View";
export var createEmptyMessageRenderer = function (_a) {
    var text = _a.text;
    return function emptyMessageRenderer() {
        return (React.createElement(OptionRoot, { spaceVertical: INDENT.s },
            React.createElement(Text, { view: TEXT_VIEW.secondary, truncate: true }, text)));
    };
};
//# sourceMappingURL=emptyMessageRenderer.js.map